/* eslint-disable camelcase */
import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { InputText } from 'primereact/inputtext';
import { Menu } from 'primereact/menu';
import { Tooltip } from 'primereact/tooltip';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import ExpiredIcon from '../../../assets/stalledIcon.png';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import { AssignmentTabIndex, CaStatusNames, CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import { caDetails } from '../type';
import NewConversationLog from '../../coaching/conversationLogs/newConversationLog/NewConversationLog';
import { selectCurrentEmpid, selectCurrentUser } from '../../../pages/login/authSlice';

interface CaDashboardTable {
    caMangerTlData: any;
    fromPage: string;
    setActiveIndex?: (e: number) => void;
    setSelectedEmployee?: (e: caDetails | undefined) => void;
    setVia?: (e: string) => void;
    // isCurrentTeam?: boolean;
}

export const CaDashboardTable = (props: CaDashboardTable) => {
    const [selectedRow, setSelectedRow] = useState<caDetails | any>();
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState<any>();
    const [pagination, setPagination] = useState<any>({ first: 0, rows: 5 });
    const [viewState, setViewState] = useState<string>('new');
    const [showNewConversationModal, setshowNewConversationModal] = useState(false);
    const [correctiveActionData, setCorrectiveActionData] = useState<any>([]);
    const loggedUser = useSelector(selectCurrentEmpid);
    const loggedEmpUserName = useSelector(selectCurrentUser);

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            employee_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            scorecard_role_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            create_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
            author_employee_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            severity_level_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            ca_status_name: { value: null, matchMode: FilterMatchMode.CONTAINS },
            ca_training_status: { value: null, matchMode: FilterMatchMode.CONTAINS },
        });
        setGlobalFilterValue('');
    };
    useEffect(() => {
        const correctiveActionData = props.caMangerTlData?.map((item: any) => {
            const caItem = { ...item };
            caItem.ca_training_status = item.in_training ? 'Training' : 'Production';    
            return caItem;
        });
        setCorrectiveActionData(correctiveActionData);
    }, [props.caMangerTlData]);
    // console.log('props.isCurrentTeam', props.isCurrentTeam);
    const onGlobalFilterChange = (e: any) => {
        const value = e.target.value;
        const afilters = { ...filters };

        if (afilters.global !== undefined) {
            afilters.global.value = value;
        }
        setFilters(afilters);
        setGlobalFilterValue(value);
        localStorage.setItem('ca-dashobard-table-dt-state-local-globalFilter', JSON.stringify(value));
    };

    const menu = useRef<Menu | any>();
    const items: any = [];
    items.push(
        {
            label: 'Update Corrective Actions',
            icon: 'pi pi-pencil',
            visible:
                [
                    CaStatusNames.Draft,
                    CaStatusNames.ApprovalPending,
                    CaStatusNames.Approved,
                    CaStatusNames.Rejected,
                    CaStatusNames.Release,
                ].includes(selectedRow?.ca_status_name) && selectedRow?.expired === false,
            command: () => {
                props.setSelectedEmployee?.(selectedRow);
                props.setActiveIndex?.(AssignmentTabIndex.Updates);
                props.setVia?.('button');
            },
        },
        {
            label: 'View Corrective Actions',
            icon: 'pi pi-eye',
            visible: true,
            command: () => {
                props.setSelectedEmployee?.(selectedRow);
                props.setActiveIndex?.(AssignmentTabIndex.View);
            },
        },
        {
            label: 'Create New Corrective Actions',
            icon: 'pi pi-plus',
            visible: true,
            command: () => {
                props.setSelectedEmployee?.(selectedRow);
                props.setActiveIndex?.(AssignmentTabIndex.Assignment);
                props.setVia?.('button');
            },
        },
        {
            label: 'Create Discussions',
            icon: 'pi pi-plus',
            visible: true,
            command: () => {
                // props.setSelectedEmployee?.(selectedRow);
                // props.setActiveIndex?.(AssignmentTabIndex.Assignment);
                // props.setVia?.('button');
                setshowNewConversationModal(true);
                
            },
        }
    );
    const renderDiscussionModal = ()=>{
        return(
            <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedUser}
                    authorName={loggedEmpUserName}
                    recieverId={selectedRow.employee_number}
                    receiverName={selectedRow.employee_name}
                    via={CoachingTabs.CorrectiveActions}
                    //date={props.date}
                    //getData={(data: any) => { handleGetData(data) }}
                    coachingEntityId={selectedRow.corrective_action_id}
                    coachingEntityTypeId={CoachingEntityTypes.CorrectiveActions}
                />
        );
    }
    const popupMenuClickHandler = (e: any, rowData: any) => {
        e.preventDefault();
        menu.current?.toggle(e);
        setSelectedRow(rowData);
    };

    const actionTemplate = (rowData: any) => {
        if (rowData !== null) {
            if (props.fromPage === 'CorrectiveActionsAssignment') {
                return (
                    <Button
                        type="button"
                        icon="pi pi-ellipsis-v"
                        onClick={(e: any) => {
                            popupMenuClickHandler(e, rowData);
                        }}
                    />
                );
            }
            if (props.fromPage === 'ScorecardDashboard') {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="button"
                            onClick={() => {
                                props.setSelectedEmployee?.(rowData);
                            }}
                            icon={'pi pi-pencil'}
                            style={{
                                background: 'transparent',
                                border: '#CECECD 1px solid',
                                color: '#3F5765',
                            }}
                        />
                    </div>
                );
            }

            if (props.fromPage === 'PendingApprovals') {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Button
                            type="button"
                            onClick={() => {
                                props.setSelectedEmployee?.(rowData);
                                if (
                                    rowData.ca_status_name === CaStatusNames.ApprovalPending ||
                                    rowData.ca_status_name === CaStatusNames.Approved ||
                                    rowData.ca_status_name === CaStatusNames.Rejected
                                ) {
                                    props.setActiveIndex?.(AssignmentTabIndex.Updates - 1);
                                    props.setVia?.('button');
                                } else if (rowData.ca_status_name === CaStatusNames.Release) {
                                    props.setActiveIndex?.(AssignmentTabIndex.Acknowledged - 1);
                                    props.setVia?.('button');
                                } else {
                                    props.setActiveIndex?.(AssignmentTabIndex.View - 1);
                                }
                            }}
                            icon={
                                rowData.ca_status_name === CaStatusNames.ApprovalPending ||
                                rowData.ca_status_name === CaStatusNames.Approved ||
                                rowData.ca_status_name === CaStatusNames.Release ||
                                rowData.ca_status_name === CaStatusNames.Rejected
                                    ? 'pi pi-pencil'
                                    : 'pi pi-eye'
                            }
                            style={{
                                background: 'transparent',
                                border: '#CECECD 1px solid',
                                color: '#3F5765',
                            }}
                        />
                    </div>
                );
            }
        }
        return <div />;
    };

    // Reset filters
    const resetFilters = () => {
        setGlobalFilterValue('');
        initFilters();
        setPagination({ first: 0, rows: 5 });
        localStorage.removeItem('ca-dashobard-table-dt-state-local');
        localStorage.removeItem('ca-dashobard-table-dt-state-local-pagination');
        localStorage.removeItem('ca-dashobard-table-dt-state-local-globalFilter');
    };
    const renderHeader = () => {
        return (
            <div className="exportexcel">
                <Button type="button" className='btn-primary' icon="pi pi-filter-slash" label="Clear" onClick={resetFilters} />
                <span className="p-input-icon-left ms-3">
                    <i className="pi pi-search" />
                    <InputText
                        value={globalFilterValue}
                        onChange={onGlobalFilterChange}
                        placeholder="Keyword Search"
                    />
                </span>
            </div>
        );
    };
    const header = renderHeader();

    const expiredStatusIcon = (rowData: any) => {
        return (
            <div>
                {rowData.expired ? (
                    <img className="justify-content-left caExpiredStatusIcon" src={ExpiredIcon} alt="Expired" />
                ) : (
                    ''
                )}
                <Tooltip target=".caExpiredStatusIcon" position="top">
                    <div id="expiredCa" className="tooltip-content">
                        <span style={{ minWidth: '1px' }}>Expired</span>
                    </div>
                </Tooltip>
            </div>
        );
    };

    // // Load saved filters when component mounts
    useEffect(() => {
        initFilters();
        const savedFilters = localStorage.getItem('ca-dashobard-table-dt-state-local');
        if (savedFilters) {
            setFilters(JSON.parse(savedFilters));
        }
        const savedPagination = localStorage.getItem('ca-dashobard-table-dt-state-local-pagination');
        if (savedPagination) {
            setPagination(JSON.parse(savedPagination));
        }

        const savedGlobalFilter = localStorage.getItem('ca-dashobard-table-dt-state-local-globalFilter');
        if (savedGlobalFilter) {
            setGlobalFilterValue(JSON.parse(savedGlobalFilter));
        }
    }, []);

    // Save filters to localStorage when they change
    const onFilterChange = (e: { filters: any }) => {
        setFilters(e.filters);
        localStorage.setItem('ca-dashobard-table-dt-state-local', JSON.stringify(e.filters));
    };

    // Save pagination to localStorage when they change
    const onPageChange = (e: { first: number; rows: number }) => {
        const newPagination: any = { first: e.first, rows: e.rows };
        setPagination(newPagination);
        localStorage.setItem('ca-dashobard-table-dt-state-local-pagination', JSON.stringify(newPagination));
    };

    return (
        <div style={{ minWidth: '800px' }}>
            <Menu model={items} popup ref={menu} id="popup_menu" className="headerFeatures" />

            <DataTable
                paginator
                scrollable
                rows={pagination.rows}
                first={pagination.first}
                onPage={onPageChange}
                onFilter={onFilterChange}
                header={header}
                value={correctiveActionData}
                className="ca-dashboard"
                dataKey="corrective_action_id"
                emptyMessage="No Records"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                rowsPerPageOptions={[5, 10, 25, 50]}
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                filters={filters}
                filterDisplay="row"
                globalFilterFields={[
                    'employee_name',
                    'scorecard_role_name',
                    'create_date',
                    'author_employee_name',
                    'severity_level_name',
                    'ca_status_name',
                    'release_date',
                    'expired_date',
                    'ca_training_status',
                ]}
            >
                <Column
                    headerStyle={{ width: '1px' }}
                    bodyStyle={{ width: '3.5rem' }}
                    body={expiredStatusIcon}
                />
                <Column
                    header="Employee"
                    field="employee_name"
                    sortable
                    sortField="employee_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Role"
                    field="scorecard_role_name"
                    sortable
                    sortField="scorecard_role_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Creation Date"
                    field="create_date"
                    sortable
                    sortField="create_date"
                    body={(date) => (date.create_date ? DateTemplate(date?.create_date) : '--')}
                    filter
                    filterPlaceholder="Search by date"
                    style={{ minWidth: '10rem' }}
                    // dataType="date" filterElement={dateFilterTemplate}
                />
                <Column
                    header="Author"
                    field="author_employee_name"
                    sortable
                    sortField="author_employee_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Category"
                    field="ca_category_name"
                    sortable
                    sortField="ca_category_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Severity Level"
                    field="severity_level_name"
                    sortable
                    sortField="severity_level_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Status"
                    field="ca_status_name"
                    sortable
                    sortField="ca_status_name"
                    filter
                    filterPlaceholder="Search by name"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Issued"
                    field='ca_training_status'
                    sortable
                    sortField='ca_training_status'
                    filter
                    filterPlaceholder="Search by training status"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Release"
                    field="release_date"
                    sortable
                    sortField="release_date"
                    body={(date) => (date.release_date ? DateTemplate(date?.release_date) : '--')}
                    filter
                    filterPlaceholder="Search by date"
                    style={{ minWidth: '10rem' }}
                />
                <Column
                    header="Expiry"
                    field="expired_date"
                    sortable
                    sortField="expired_date"
                    body={(date) => (date.expired_date ? DateTemplate(date?.expired_date) : '--')}
                    filter
                    filterPlaceholder="Search by date"
                    style={{ minWidth: '10rem' }}
                />
                {props.fromPage === 'PendingApprovals' ? (
                    <Column
                        header="Current Approver Role"
                        field="current_ca_approver_role_name"
                        sortable
                        sortField="current_ca_approver_role_name"
                        style={{ minWidth: '10rem' }}
                    />
                ) : (
                    <Column />
                )}
                <Column body={(data) => actionTemplate(data)} frozen  alignFrozen='right'/>
            </DataTable>            
        {showNewConversationModal && renderDiscussionModal()}
        </div>
    );
};

export default CaDashboardTable;
